let signOutFn: ((reason?: string) => Promise<void>) | null = null;

export const AuthController = {
    setSignOutFunction: (fn: (reason?: string) => Promise<void>) => {
        signOutFn = fn;
    },
    signOut: async (reason?: string) => {
        if (signOutFn) {
            await signOutFn(reason);
        } else {
            console.warn('No signOut function has been registered.');
        }
    }
};
